import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/users';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageUsers() {
  return (
    <Root title={PAGE_TITLE.USERS}>
      <Container>
        <Component />
      </Container>
    </Root>
  );
};
